.head {
  margin: 4px 4px 4px;
  font-size: 24px;
  font-weight: 700;
  letter-spacing: -0.01em;
}

/* Карточка подписки в списке целиком — кнопка: нажатие открывает её экран. */
.item {
  display: block;
  width: 100%;
  padding: var(--pad);
  text-align: left;
  background: var(--surface);
  border: 1px solid var(--card-border);
  border-radius: var(--r-lg);
  cursor: pointer;
  -webkit-tap-highlight-color: transparent;
}

.item:active {
  background: var(--surface-sunken);
}

.between {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
}

.figure {
  margin-top: 14px;
  align-items: flex-end;
}

.days {
  font-size: 30px;
  font-weight: 700;
  line-height: 1;
  font-variant-numeric: tabular-nums;
}

.dim {
  font-size: 13px;
  color: var(--muted);
}

.after {
  margin-left: 6px;
}

.meta {
  margin-top: 12px;
}

.inline {
  display: inline-flex;
  align-items: center;
  gap: 6px;
}

.chevron {
  color: var(--muted);
}

/* Экран одной подписки */
.stack {
  display: flex;
  flex-direction: column;
  gap: 10px;
  margin-top: 14px;
}

.hint {
  margin: 0 2px;
  font-size: 13px;
  color: var(--muted);
}

.facts {
  background: var(--surface-sunken);
  border: 1px solid var(--card-border);
  border-radius: var(--r-md);
}

.fact {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
  padding: 12px 14px;
}

.fact + .fact {
  box-shadow: inset 0 1px 0 var(--line);
}

.value {
  text-align: right;
  white-space: nowrap;
  font-variant-numeric: tabular-nums;
}

.sub {
  display: block;
  font-size: 12px;
  color: var(--muted);
}
